import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

import { LocationInfoMap } from '@fcom/dapi/interfaces';
import { getCityName } from '@fcom/common/utils/booking.utils';

@Component({
  selector: 'fin-included-product-heading',
  templateUrl: './included-product-heading.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IncludedProductHeadingComponent implements OnInit, OnChanges {
  @Input() locationCodes: string[] = [];

  @Input()
  locations: LocationInfoMap;

  @Input()
  operatedByText: string | undefined;

  showLocations: string[];

  ngOnInit(): void {
    this.showLocations = this.locationCodes.map((locationCode) => getCityName(locationCode, this.locations));
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['locationCodes']?.firstChange) {
      this.showLocations = this.locationCodes.map((locationCode) => getCityName(locationCode, this.locations));
    }
  }
}
